import { render, staticRenderFns } from "./EventProfiles.vue?vue&type=template&id=65551fcc"
import script from "./EventProfiles.vue?vue&type=script&lang=js"
export * from "./EventProfiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports